import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { UploadZone } from "../../../../../../common/AudioRecognize/components/UploadZone";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { AppButton } from "../../../../../../shared/components/AppButton";
import { AppLinearLoading } from "../../../../../../shared/components/AppLoading/AppLinearLoading";
import { useAudioRecognize } from "../../../../hooks/use-audio-recognize";
import { useFileUpload } from "../../../../hooks/use-file-upload";
import {
  selectEstimateDuration,
  selectProgress,
} from "../../../../redux/selectors";
import { MeetingModalInfo } from "../../../Modals/MeetingInfoModal";
import { useAppModals } from "../../../../../../app/state/modalSlice/hook/use-app-modals";
import { WarningModal } from "../../../../../../common/Components/Modals/components/WarningModal";
import styles from "./styles.module.css";
import { MeetingHeader } from "../MeetingHeader";
import { AttachedFileModal } from "../../../../../Modals/AttachedFileModal";
import { ACCEPTABLE_AUDIO_FORMAT } from "../../../../../Files/constants";

interface Props {
  className?: string;
}

export const UploadDataMeeting = ({ className }: Props) => {
  const {
    file,
    handleFileUpload,
    handleDrop,
    handleClick,
    handleOk,
    handleCancel,
  } = useFileUpload();
  const { recognizeMeta, startRecognition, startRecognitionWithCheckSpeakers } =
    useAudioRecognize();
  const estimateDuration = useAppSelector(selectEstimateDuration);
  const { handleOpenModal, handleCloseModal } = useAppModals();
  const progress = useAppSelector(selectProgress);
  const { t } = useTranslation();

  return (
    <div className={styles["container"]}>
      <MeetingHeader
        recognizeMeta={recognizeMeta}
        openAttachedFileModal={handleOpenModal}
      />
      <div className={styles["upload-wrapper"]}>
        <UploadZone
          uploadZoneStyle={"custom"}
          uploadMessage={t("meetings.upload_zone_message")}
          dropHandler={handleDrop}
          zoneMode={recognizeMeta?.recognize_mode}
          info={estimateDuration ?? ""}
          handleFileUpload={handleFileUpload}
          className={classNames(
            styles["upload-zone-custom"],
            recognizeMeta?.recognize_mode === "upload"
              ? styles["upload-mode"]
              : styles["info-mode"],
          )}
        />
        <AppButton
          buttonType={"contained"}
          onClick={startRecognitionWithCheckSpeakers}
        >
          {t("common.recognize")}
        </AppButton>
      </div>
      {recognizeMeta?.is_recognize && (
        <div className={styles.progress}>
          <AppLinearLoading
            variant={"determinate"}
            value={parseFloat(progress ?? "")}
            className={styles.loading}
          />
          <div className={styles["progress-label"]}>{progress}</div>
        </div>
      )}
      <WarningModal
        handleOk={startRecognition}
        closeModal={() => handleCloseModal("warning_modal")}
      />
      <MeetingModalInfo
        handleOk={handleOk}
        handleCancel={handleCancel}
        closeModal={() => handleCloseModal("meeting_info_modal")}
      />
      <AttachedFileModal
        extensions={ACCEPTABLE_AUDIO_FORMAT}
        onClose={handleCloseModal}
        handleClick={handleClick}
        multiple={false}
      />
    </div>
  );
};
